module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery && _vm.cityFix) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择区"
    },
    model: {
      value: (_vm.filters.dvalue),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dvalue", $$v)
      },
      expression: "filters.dvalue"
    }
  }, _vm._l((_vm.doptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.workerName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workerName", $$v)
      },
      expression: "filters.workerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone", $$v)
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "身份证号"
    },
    model: {
      value: (_vm.filters.widNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "widNo", $$v)
      },
      expression: "filters.widNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getMemberList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showAddry
    }
  }, [_vm._v("新增人员")])], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.dcLoading
    },
    on: {
      "click": _vm.handledc
    }
  }, [_vm._v("导出")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.memberlist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.sex === '0' ? '女' : "男"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "widNo",
      "label": "身份证号",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同状态",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.laborContract === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未签订")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("已签订")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保险状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.buyInsurance === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未购买")])]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.insurancetypeName))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerTypeName",
      "label": "岗位",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enterDate",
      "label": "入职日期",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "所属企业",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), (_vm.bshow) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2974640243)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "phone", $$v)
      },
      expression: "editForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.gwvalue),
      callback: function($$v) {
        _vm.gwvalue = $$v
      },
      expression: "gwvalue"
    }
  }, _vm._l((_vm.gwoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMember.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增人员",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addryFormVisible),
      callback: function($$v) {
        _vm.addryFormVisible = $$v
      },
      expression: "addryFormVisible"
    }
  }, [_c('el-form', {
    ref: "addryForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addryForm,
      "label-width": "120px",
      "rules": _vm.addryFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "name", $$v)
      },
      expression: "addryForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "widNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.widNo),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "widNo", $$v)
      },
      expression: "addryForm.widNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "phone", $$v)
      },
      expression: "addryForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员岗位"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.gwvalue),
      callback: function($$v) {
        _vm.gwvalue = $$v
      },
      expression: "gwvalue"
    }
  }, _vm._l((_vm.gwoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "劳动合同"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addryForm.laborContract),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "laborContract", $$v)
      },
      expression: "addryForm.laborContract"
    }
  }, _vm._l((_vm.laboroptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入职日期",
      "prop": "enterDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addryForm.selEnterDate),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "selEnterDate", $$v)
      },
      expression: "addryForm.selEnterDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员保险"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addryForm.buyInsurance),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "buyInsurance", $$v)
      },
      expression: "addryForm.buyInsurance"
    }
  }, _vm._l((_vm.insuranceoptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addryForm.buyInsurance == '1') ? _c('el-row', [_c('div', {
    staticClass: "checkbox-wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "label": "保险类别"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.bxselectedValues),
      callback: function($$v) {
        _vm.bxselectedValues = $$v
      },
      expression: "bxselectedValues"
    }
  }, _vm._l((_vm.bxoptions), function(item) {
    return _c('el-checkbox', {
      key: item.Mpid,
      staticClass: "checkbox-item",
      attrs: {
        "label": item.MpValue
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.MpCn) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addryFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddry.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-960dfb20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav/enterpriseMember.vue
// module id = 840
// module chunks = 2